/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import Tysiav2PhoneCall from 'DesignSystem/Svgs/Tysiav2PhoneCall/index'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/Phones/Phone",
  onClick
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let personPhoneValueData = fromData.useDataFormat({ viewPath,
context: 'person_phone',
format: fromFormat.personPhone,
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type="secondary"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceXxs}
>
{childProps => (
<React.Fragment>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2PhoneCall
{...childProps}
  viewPath={`${viewPath}/Tysiav2PhoneCall`}
 width={12}
 height={12}
/>
)}
</TysiaButtonIcon>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 data="person_phone"
 format="/Data/format.js personPhone"
 text={personPhoneValueData}
/>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}